export default __webpack_public_path__ + "media/images/portfolio/width-600/portfolio-13-48ce845f651ae945cccd4470a63ba4c4.jpg";